import styled, { css } from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import {
  borderRadius8,
  borderRadius16,
  boxShadow815Grey,
  standardFocusState,
} from 'approot/shared/styles/borders.style';
import { PrimaryButtonLink } from 'approot/shared/styles/buttons/primary-button.style';
import {
  grey1,
  grey5,
  grey9,
  purple7,
} from 'approot/shared/styles/colours.style';
import {
  fontSize16,
  fontWeightNormal,
} from 'approot/shared/styles/typography.style';
import {
  spacing8,
  spacing16,
  spacing24,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { Box } from 'approot/shared/design-system/box/box.style';

export const StudentConclusionButton = styled(PrimaryButtonLink)`
  ${boxShadow815Grey}
`;

export const StudentConclusionChoiceContainer = styled.button`
  background-color: ${grey1};
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius16)};
  cursor: pointer;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: ${rem(spacing16)};
  min-width: ${rem(256)};
  overflow: hidden;
  padding: ${rem(spacing24)};
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    border-color: ${purple7};
    box-shadow:
      0px 16px 32px 0px rgba(83, 29, 171, 0.16),
      0px 4px 12px -4px rgba(83, 29, 171, 0.12);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  ${standardFocusState}
`;

const actionsCss = css`
  border-radius: ${rem(borderRadius8)};
  display: inline-flex;
  align-items: center;
  font-size: ${rem(fontSize16)};
  font-weight: ${fontWeightNormal};
  height: ${rem(40)};
  justify-content: center;
  min-width: ${rem(80)};
  padding: ${rem(spacing8)} ${rem(spacing16)};
  pointer-events: none;
  width: 100%;
`;

export const StudentConclusionChoiceSecondaryAction = styled.span`
  background-color: ${grey1};
  border: 1px solid ${grey5};
  color: ${grey9};
  ${actionsCss}
`;

export const StudentConclusionChoicePrimaryAction = styled.span`
  background-color: ${purple7};
  border: 2px solid ${purple7};
  color: ${grey1};
  ${actionsCss}
`;

export const StudentConclusionOptionContainer = styled(Box).attrs({
  $flexDirection: 'column',
  $alignItems: 'center',
  $gap: spacing16,
})`
  ${mediaUp.md`
    padding: ${rem(spacing40)};
  `}
`;
